import axiosClient from './axiosClient';

const SurveyApi = {
  getList: (data) => {
    return axiosClient.post('/api/survey/list', data);
  },
    getMysurveyList: (data) => {
    return axiosClient.post('/api/survey/MySurvey', data);
  },
  Approve: (data) => {
    return axiosClient.post('/api/survey/approvePage', data);
  },
  create: (data) => {
    return axiosClient.post('/api/survey/create', data);
  },
  SurveyApproved: (data) => {
    return axiosClient.post('/api/survey/surveyApproval', data);
  },
  getById: (id) => {
    return axiosClient.post('/api/survey/view', { id });
  },
  submit: (data) => {
    return axiosClient.post('/api/survey/submit', data);
  },
  getCategoryDropdown: () => {
    return axiosClient.post('/api/category/dropdown', {});
  },

  update: (data) => {
    return axiosClient.post('/api/survey/update', data);
  },
    status: (data) => {
    return axiosClient.post('/api/survey/surveyStatus', data);
  },

  delete: (id) => {
    return axiosClient.post('/api/survey/delete', { id });
  },

  getPeriodDropdown: () => {
    return axiosClient.post('/api/period/dropdown', {});
  },

  getDepartmentDropdown: () => {
    return axiosClient.post('api/department/dropdown', {});
  },

  getUserDropdown: (department_ids) => {
    return axiosClient.post('api/newusers/dropDown/employee', {
      department_ids,
    });
  },

  getApprovalMember: (department_ids) => {
    return axiosClient.post('api/survey/approvalMember', {
      department_ids,
    });
  },

};

export default SurveyApi;
